module.exports = __webpack_public_path__ + "static/media/ir.9023419c.svg";